import { css, jsx } from '@emotion/react';
import { Typography, Icon } from '@zapier/design-system';
import { Link, Button } from 'react-aria-components';

const StatusChipStyles = {
  root: css`
    display: inline-flex;
    align-items: center;
    gap: var(--zds-space-4);
    height: var(--zds-size-small);
    border: var(--zds-border-width-default) solid var(--zds-status-success);
    border-radius: var(--zds-radius-default);
    padding-left: var(--zds-space-4);
    padding-right: var(--zds-space-6);
    background-color: var(--zds-status-success-weakest);
    ${Typography.Body3}

    &[data-focus-visible] {
      outline: var(--zds-border-focus);
      outline-offset: 2px;
    }

    &[data-hovered] {
      background-color: var(--zds-status-success-weaker);
    }

    &[data-size='compact'] {
      ${Typography.MinimalPrint3}
    }

    &[data-size='medium'] {
      height: var(--zds-size-medium);
      gap: var(--zds-space-6);
    }

    &[data-variant='warning'] {
      border-color: var(--zds-status-warning-weaker);
      background-color: var(--zds-status-warning-weakest);

      &[data-hovered] {
        background-color: var(--zds-background-weaker);
      }
    }

    &[data-variant='error'] {
      border-color: var(--zds-status-error);
      background-color: var(--zds-status-error-weakest);

      &[data-hovered] {
        background-color: var(--zds-status-error-weaker);
      }
    }
  `
};
const StatusChip = ({ children, href, onPress, size, target, variant }) => {
  const getIconProps = () => {
    const iconSize = size === "medium" ? "var(--zds-size-20)" : "var(--zds-size-16)";
    if (variant === "warning") {
      return {
        name: "alertCircleColor",
        color: void 0,
        size: iconSize
      };
    } else if (variant === "error") {
      return {
        name: "formXCircle",
        color: "StatusErrorStronger",
        size: iconSize
      };
    } else {
      return {
        name: "formCheckCircle",
        color: "StatusSuccessStronger",
        size: iconSize
      };
    }
  };
  if (href) {
    return jsx(
      Link,
      { css: StatusChipStyles.root, "data-size": size, "data-variant": true, "data-zds": true, href, onPress, target },
      jsx(Icon, Object.assign({}, getIconProps())),
      children
    );
  }
  return jsx(
    Button,
    { css: StatusChipStyles.root, "data-size": size, "data-variant": variant, "data-zds": true, onPress },
    jsx(Icon, Object.assign({}, getIconProps())),
    children
  );
};

export { StatusChip };
//# sourceMappingURL=StatusChip.es.js.map
